module.exports = __webpack_public_path__ + "img/vr.b3008b83.png";